var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isNextSpeakerButtonVisible)?_c('button',{staticClass:"player__center-btn common-btn center",on:{"~click":function($event){return _vm.clickNextSpeakerButton()}}},[_vm._v("\n    "+_vm._s(_vm.$t('mafia.button.end_speech'))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }